import { capitalizeFirst } from "./capitalizeFirst";

/**
 * Converts hello_world to Hello World
 */
function snakeToTitleWords(snakeStr: string) {
  return snakeStr.split("_").map(capitalizeFirst).join(" ");
}

/**
 * Formats a snake case field name, e.g. hello_world to Hello World, unless it
 * is a metadata field, which only has its first letter capitalized:
 * metadata.some_key to Metadata.some_key.
 *
 * A name without underscores only has its first letter capitalized.
 */
export const formatFieldName = (name: string) => {
  if (name.includes("metadata.")) {
    return capitalizeFirst(name);
  }
  return snakeToTitleWords(name);
};
